/* eslint-disable no-console */
import { CID } from 'multiformats/cid';

export enum Node {
  INFURA = 0,
  CLOUDFLARE = 1,
  PINATA = 2,
  IPFS = 3,
  DWEB = 4,
  VERSUM = 5,
}

export const ensureCIDv1 = (cid: string) => {
  if (cid === '') {
    console.warn('empty cid -----<');
    return '';
  }

  if (!cid.startsWith('baf')) {
    cid = CID.parse(cid).toV1().toString();
  }
  return cid;
};

export const getURLFromIPFSURI = (uri: string, type: Node = Node.IPFS) => {
  const parts = uri.replace('ipfs://', '').split('/');
  const cid = parts[0];
  const cidv1 = ensureCIDv1(cid);
  const path = parts.length ? `/${parts.slice(1).join('/')}` : '';

  switch (type) {
    case Node.CLOUDFLARE:
      return `https://cloudflare-ipfs.com/ipfs/${cidv1}${path}`;
    case Node.INFURA:
      return `https://${cidv1}.ipfs.infura-ipfs.io${path}`;
    case Node.PINATA:
      return `https://gateway.pinata.cloud/ipfs/${cidv1}${path}`;
    case Node.IPFS:
      return `https://ipfs.io/ipfs/${cidv1}${path}`;
    case Node.DWEB:
      return `https://${cidv1}.ipfs.dweb.link${path}`;
    case Node.VERSUM:
      return `https://ipfs.versum.cloud/ipfs/${cidv1}${path}`;
    default:
      return `https://ipfs.io/ipfs/${cidv1}${path}`;
  }
};

// converts ipfs:// if match or returns https://
export const getURLFromIPFSorHTTP = (value = '', node = Node.INFURA) => {
  if (value && value.indexOf('ipfs://') !== -1) {
    return getURLFromIPFSURI(value, node);
  }

  return value;
};
